// extracted by mini-css-extract-plugin
module.exports = {"editorDiv":"styles_editorDiv__3v1lA","buttonStyle":"styles_buttonStyle__206xl","ant-btn-primary":"styles_ant-btn-primary__3Nv9H"};